"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtmReporter = void 0;
function gtmReporter(info, config) {
    let loadedDataLayer = !!window.dataLayer;
    const baseMetadata = {
        service: info.service,
        domain: window.location.host,
        environment: info.environment,
        version: info.version,
    };
    const reporter = {
        ...config,
        addMetadata: function (metadata) {
            if (window.dataLayer) {
                // Lazy load base metadata, e.g. if GTM isn't ready yet.
                if (!loadedDataLayer) {
                    window.dataLayer.push(baseMetadata);
                    loadedDataLayer = true;
                }
                window.dataLayer.push(metadata);
            }
        },
        trackEvent: function (event) {
            reporter.addMetadata({
                ...event.metadata,
                ...event.tags,
                ...event.metrics,
                event: event.message,
                level: event.level,
            });
        },
        addBreadcrumb: function (breadcrumb) {
            reporter.addMetadata({
                ...breadcrumb.metadata,
                event: breadcrumb.message,
            });
        },
        setUser: function (user) {
            if (user) {
                reporter.addMetadata({ user });
            }
        },
        setRouteName: function (routeName) {
            reporter.addMetadata({ routeName });
        },
        setPageName: function (pageName) {
            reporter.addMetadata({ pageName });
        },
    };
    if (loadedDataLayer) {
        reporter.addMetadata(baseMetadata);
    }
    return reporter;
}
exports.gtmReporter = gtmReporter;
//# sourceMappingURL=gtmReporter.js.map